"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getHasScope = function _getHasScope(user, scope) {
  return user.scopes.indexOf(scope) !== -1;
};
/**
 * @param {Object} portal
 * @param {Object} user
 * @return {Array}
 */


var getUserScopes = function getUserScopes(portal, user) {
  var portalScopes = [];

  if (_getHasScope(user, 'salesaccelerator-access')) {
    portalScopes.push('Sales-Pro');
  } else if (_getHasScope(user, 'crm-access')) {
    portalScopes.push('Sales-Free');
  }

  if (portal.product_type === 'basic') {
    portalScopes.push('Marketing-Basic');
  } else if (portal.product_type === 'pro') {
    portalScopes.push('Marketing-Pro');
  } else if (portal.product_type === 'enterprise') {
    portalScopes.push('Marketing-Enterprise');
  }

  return portalScopes;
};

var _default = getUserScopes;
exports.default = _default;
module.exports = exports.default;